import React, {useEffect, useState} from "react";
import { Button, Autocomplete, Stack, TextField, Typography, FormGroup, FormControlLabel, Checkbox, Grid } from "@mui/material";
import {Box} from "@mui/system";
import UserUtils from "../utils/userUtils";
import Api from "../services/Api";


export const NewUserForm = ({submitAsync, assignRoles, sendEmail, ...props}) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [role, setRole] = useState(UserUtils.RoleObjects['standard']);
  const [sendEmailCheck, setSendEmailCheck] = useState(false);
  const [roleOptions, setOptions] = useState([]);


  useEffect(() => {
    const getRoles = async () => {
      let roles = await Api.getAssignableRoles();
      if (roles){
        let roleObjs = [];
        roles.forEach(x => roleObjs.push(UserUtils.RoleValueToObject(x)));
        setOptions(roleObjs);
      }
    }
    if (assignRoles){
      getRoles();
    }
  }, [assignRoles, setOptions]);

  const handleSubmit = async () => {  
    if (email === "" || username === "" || role === null){
      return;
    }
    // let success = await Api.postNewUser(email, username, role);
    let success = await submitAsync(email, username, role.value, sendEmailCheck);
    if (success){
      setEmail("");
      setUsername("");
      setSendEmailCheck(false);
      setRole(UserUtils.RoleObjects['standard']);
    }
  }

  const disableSubmit = () => {
    return (email === "" || username === "" || role < 0);
  }

  return (
    <Stack sx={{textAlign: 'center'}} spacing={1} alignItems="stretch">
      <Typography variant="h5">
        Create New User
      </Typography>
      <TextField 
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField 
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      {assignRoles &&
        <Autocomplete
          options={roleOptions}
          getOptionLabel={(obj) => UserUtils.RoleObjToRoleString(obj)}
          value={role}
          onChange={(event, newValue) => {
            setRole(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Assigned Role"
              aria-label="Assign Role Combo Box"
            />
          )}
        />}
        {sendEmail &&
        <Box sx={{textAlign: 'center'}}>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={sendEmailCheck} onClick={() => setSendEmailCheck(!sendEmailCheck)}/>} label={"Send Welcome Email"}/>
          </FormGroup>
        </Box>
        }
      <Box>

        <Button sx={{width: "50%"}} onClick={handleSubmit} variant="outlined" disabled={disableSubmit()}>
          Submit
        </Button>
      </Box>
    </Stack>
  )
}